import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CashReceiptEnums } from 'src/app/enum/cash-receipt-enums';
import { IncomeConceptEnum } from 'src/app/enum/income-concept-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { CashReceiptPrintModel } from 'src/app/models/print/wallet/cash-receipt-print.model';
import { CashReceiptModel } from 'src/app/models/wallet/cash-receipt.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { AccountingInterfaceService } from 'src/app/services/invoicing/accounting-interface.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CashReceiptService } from 'src/app/services/wallet/cash-receipt.service';
import Swal from 'sweetalert2';
import { CashReceiptPrintingRangeComponent } from '../cash-receipt-printing-range/cash-receipt-printing-range.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-register-cash-receipt',
  templateUrl: './register-cash-receipt.component.html',
  styleUrls: ['./register-cash-receipt.component.scss'],
  standalone: false
})
export class RegisterCashReceiptComponent implements OnInit {

  @ViewChild('printingRangeModal') printingRangeModalComponent?: CustomModalComponent | null = null;

  accountingInterfaceCode: string = '';
  branchId: number = 0;
  cashReceiptId: number = 0;
  cashReceiptContract: CashReceiptModel = new CashReceiptModel()
  cashReceiptsPrintModel: Array<CashReceiptPrintModel> = new Array<CashReceiptPrintModel>();
  cashReceiptStateOpen = CashReceiptEnums.abierto;
  cashReceiptStateString: string = 'Anulado';
  clientId: number = 0;
  codeCurrency: string = '';
  companyCashReceiptQuantity: number = 0;
  companyId: number = 0;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  enterpriseId: number = 0;
  formCashReceipt: FormGroup = new FormGroup({});
  iconStateCashReceipt: string = 'pi pi-lock-open';
  inputsForPrintingRangeModals$ = new BehaviorSubject<any>({
    consecutiveCashReceipt: 0
  });
  isChargeAccount: boolean = false;
  isOpened: string | undefined = undefined;
  incomeConceptCode: number = 0;
  listBranch: any[] = [];
  listClient: any[] = [];
  listEnterprise: any[] = [];
  listIncomeConcept: any[] = [];
  nameWindow: string = 'Recibos de Caja';
  openCashReceiptQuantity: number = 0;
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  quantityAdvancePayments: number = 0;
  quantityDetails: number = 0;
  quantityPayments: number = 0;
  showAccordionAdvancePayments: boolean = false;
  showAccordionDetail: boolean = false;
  showAccordionPayment: boolean = false;
  stateClientId: number | null = 0;
  titleStateCashReceipt: string = 'Cerrar';
  updateAdvances: boolean = false;
  url: string = '';
  userAuthenticated: UserModel = new UserModel();
  visibleSelectInvoice: boolean = true;
  componentPrintingRangeModal = CashReceiptPrintingRangeComponent;

  constructor(private activatedRoute: ActivatedRoute,
    private accountingInterface: AccountingInterfaceService,
    private branchService: BranchService,
    private cdr: ChangeDetectorRef,
    private confirmDialogService: ConfirmDialogService,
    private cashReceiptService: CashReceiptService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.cashReceiptContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.cashReceiptId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:unload')
  unloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const cashReceiptContractChanges = changes["cashReceiptContract"];
    const permissionUpdatableChanges = changes["permissionUpdatable"];

    if (cashReceiptContractChanges != undefined && permissionUpdatableChanges != undefined) {
      return;
    }
    if (this.cashReceiptContract.cashReceiptId === 0) {
      this.createNewCashReceipt();
    } else {
      this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
      this.formCashReceipt.enable();
      this.validateForm(this.cashReceiptContract);
    }
  }

  annulDevolution() {
    if (this.cashReceiptContract.cashReceiptId !== 0 && this.cashReceiptContract.cashReceiptId != null) {
      if (this.permissionUpdatable) {
        if (this.cashReceiptContract.cashReceiptStateId === CashReceiptEnums.anulado) {
          this.toastHandlerService.showToast(
            'warning',
            'El recibo de caja se encuentra anulado.'
          );
        } else {
          if (this.quantityDetails !== 0) {
            this.toastHandlerService.showToast(
              'error',
              'No se puede anular un documento con detalle.'
            );
            return;
          }
          Swal.fire({
            title: 'Atención',
            text: "¿Realmente desea anular el recibo de caja actual?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                this.cashReceiptContract = await firstValueFrom(this.cashReceiptService.annulCashReceipt(this.cashReceiptId));
                this.validateForm(this.cashReceiptContract);
                this.toastHandlerService.showToast(
                  'success',
                  'El recibo de caja fue anulado exitosamente.'
                );
              } catch (error) {
                console.error("Error al anular el recibo de caja: ", error);
              }
            }
          });
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para anular recibos de caja. Comuníquese con el administrador del sistema.'
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un recibo de caja.'
      );
    }
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    await this.getFirstEnterpriseByBranch();
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getAllLists('enterprises', 'incomeConcepts');
      this.resetContract();
    }
  }

  async changeCashReceiptState() {
    const hasCashReceipt = this.cashReceiptContract.cashReceiptId !== 0 && this.cashReceiptContract.cashReceiptId != null;
    if (!hasCashReceipt) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un recibo de caja.'
      );
      return;
    }

    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para cambiar estado de recibos de caja. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    const requiresConfirmation = this.cashReceiptContract.accountingInterfaceId !== 0 && this.cashReceiptContract.accountingInterfaceId != null;
    if (!requiresConfirmation || await this.confirmDialogService.confirm('Este recibo de caja ya se encuentra en una interfaz contable ¿Realmente desea cambiar su estado?')) {
      try {
        this.cashReceiptContract = await firstValueFrom(
          this.cashReceiptService.setStateCashReceipt(this.cashReceiptContract.cashReceiptId)
        );
        this.validateForm(this.cashReceiptContract);
        this.toastHandlerService.showToast(
          'success',
          'El estado del recibo de caja fue cambiado exitosamente.'
        );
      } catch (error) {
        console.error("Error al cambiar el estado.", error);
      }
    }
  }

  async changeConsecutive() {
    const branchId = this.formCashReceipt.get("branchId")?.value;
    const enterpriseId = this.formCashReceipt.get("enterpriseId")?.value;
    let consecutive = this.formCashReceipt.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Empresa.'
      );
      return;
    } else if (consecutive == null) {
      consecutive = 0;
    }

    if (consecutive == null) {
      this.createNewCashReceipt();
    } else {
      try {
        this.cashReceiptContract = await firstValueFrom(this.cashReceiptService.getCashReceiptByKeysAsync(branchId, enterpriseId, consecutive,
          this.isChargeAccount));
        this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
        this.validateForm(this.cashReceiptContract);
        this.location.replaceState(`/${this.url}/register/${this.cashReceiptContract.cashReceiptId}`);
      } catch (error) {
        this.cashReceiptContract = new CashReceiptModel();
        this.cashReceiptContract.cashReceiptId = -1;
        this.cashReceiptContract.branchId = branchId;
        this.cashReceiptContract.enterpriseId = enterpriseId;
        this.cashReceiptContract.consecutive = consecutive;
        this.validateForm(this.cashReceiptContract);
        console.error("Error al obtener el recibo de caja por claves: ", error);
      }
    }
  }

  changeEnterprise(enterpriseId: number) {
    this.enterpriseId = enterpriseId;
    this.resetContract();
  }

  resetContract() {
    this.clientId = 0;
    this.cashReceiptId = 0;
    this.stateClientId = 0;
    this.codeCurrency = "";
    this.quantityDetails = 0;
    this.quantityPayments = 0;
    this.quantityAdvancePayments = 0;
    this.cashReceiptContract = new CashReceiptModel();
    this.cashReceiptContract.branchId = this.branchId;
    this.cashReceiptContract.enterpriseId = this.enterpriseId;
    this.cashReceiptContract.isChargeAccount = this.isChargeAccount;
    this.validateForm(this.cashReceiptContract);
    this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register`) :
      this.location.replaceState(`/cash-receipt/register`);
  }

  createNewCashReceipt() {
    if (this.permissionUpdatable) {
      this.resetContract();
      this.validateCashReceipt(this.branchId);
      if (this.companyCashReceiptQuantity != 0) {
        if (this.companyCashReceiptQuantity == this.openCashReceiptQuantity) { return; }
      }

      this.cashReceiptsPrintModel = new Array<CashReceiptPrintModel>();
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear recibos de caja. Comuníquese con el administrador del sistema.'
      );
    }
  }

  deleteCashReceipt() {
    if (this.cashReceiptContract.cashReceiptId != 0 && this.cashReceiptContract.cashReceiptId != null) {
      if (this.permissionUpdatable) {
        Swal.fire({
          title: 'Atención',
          text: "¿Realmente desea eliminar el recibo de caja actual?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await firstValueFrom(this.cashReceiptService.deleteCashReceipt(this.cashReceiptId));
              this.createNewCashReceipt();
              this.toastHandlerService.showToast(
                'success',
                'El recibo de caja fue eliminado exitosamente.'
              );
            } catch (error) {
              console.error("Error al eliminar el recibo de caja: ", error);
            }
          }
        });
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para eliminar recibos de caja. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un recibo de caja.'
      );
      return;
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) window.print();
  }

  async getAccountingInterfaceCode(accountingInterfaceId: number | null) {
    if (accountingInterfaceId != null && accountingInterfaceId != 0) {
      const accountingInterface = await firstValueFrom(this.accountingInterface.getAccountingInterfaceById(accountingInterfaceId));
      if (accountingInterface) {
        this.accountingInterfaceCode = accountingInterface.consecutive.toString();
      } else {
        this.accountingInterfaceCode = '';
      }
    } else {
      this.accountingInterfaceCode = '';
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'enterprises' | 'clients' | 'incomeConcepts'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranch = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
        },
        enterprises: async () => {
          this.listEnterprise = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
        },
        clients: async () => {
          this.listClient = await firstValueFrom(this.cashReceiptService.getAllClientsForSelectAsync());
          this.cdr.detectChanges();
        },
        incomeConcepts: async () => {
          this.listIncomeConcept = await firstValueFrom(this.cashReceiptService.getAllIncomeConceptsForSelectAsync(this.branchId));
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.clients(),
          lists.enterprises(),
          lists.incomeConcepts()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formCashReceipt.get("branchId")?.value;
    const enterpriseId = this.formCashReceipt.get("enterpriseId")?.value;
    let consecutive = this.formCashReceipt.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (enterpriseId == null || enterpriseId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una Empresa.'
      );
      return;
    } else if (consecutive == null) {
      consecutive = 0;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.cashReceiptContract = await firstValueFrom(
            this.cashReceiptService.getFirstCashReceiptByKeysAsync(branchId, enterpriseId, this.isChargeAccount)
          );
          this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
          this.validateForm(this.cashReceiptContract);
          this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register/${this.cashReceiptId}`) :
            this.location.replaceState(`/cash-receipt/register/${this.cashReceiptId}`);
        } catch (error) {
          console.error('Error al obtener el primer recibo de caja:', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.cashReceiptContract = await firstValueFrom(
            this.cashReceiptService.getPreviusCashReceiptByKeysAsync(branchId, enterpriseId, consecutive, this.isChargeAccount)
          );
          this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
          this.validateForm(this.cashReceiptContract);
          this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register/${this.cashReceiptId}`) :
            this.location.replaceState(`/cash-receipt/register/${this.cashReceiptId}`);
        } catch (error) {
          console.error('Error al obtener el anterior recibo de caja:', error);
        }
        break;
      }
      case 'next': {
        try {
          this.cashReceiptContract = await firstValueFrom(
            this.cashReceiptService.getNextCashReceiptByKeysAsync(branchId, enterpriseId, consecutive, this.isChargeAccount)
          );
          this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
          this.validateForm(this.cashReceiptContract);
          this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register/${this.cashReceiptId}`) :
            this.location.replaceState(`/cash-receipt/register/${this.cashReceiptId}`);
        } catch (error) {
          console.error('Error al obtener el siguiente recibo de caja:', error);
        }
        break;
      }
      case 'last': {
        try {
          this.cashReceiptContract = await firstValueFrom(
            this.cashReceiptService.getLastCashReceiptByKeysAsync(branchId, enterpriseId, this.isChargeAccount)
          );
          this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
          this.validateForm(this.cashReceiptContract);
          this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register/${this.cashReceiptId}`) :
            this.location.replaceState(`/cash-receipt/register/${this.cashReceiptId}`);
        } catch (error) {
          console.error('Error al obtener el ultimo recibo de caja:', error);
        }
        break;
      }
    }
  }

  async getCashReceiptById() {
    try {
      this.cashReceiptContract = await firstValueFrom(this.cashReceiptService.getCashReceiptById(this.cashReceiptId));
      this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
      await this.changeBranch(this.cashReceiptContract.branchId, true);
      this.validateForm(this.cashReceiptContract);
      this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register/${this.cashReceiptId}`) :
        this.location.replaceState(`/cash-receipt/register/${this.cashReceiptId}`);
    } catch (error) {
      console.error('Error al obtener la lista de precios por ID:', error);
    }
  }

  async getClient(clientId: number | null) {
    const clientOld = this.cashReceiptContract.clientId;
    if (clientId != null && clientId != 0) {
      if (clientOld != clientId && this.quantityDetails != 0) {
        this.formCashReceipt.controls["clientId"].patchValue(clientOld);
        this.toastHandlerService.showToast(
          'warning',
          'No puede cambiar el cliente si la cuenta de cobro tiene detalle.'
        );
      } else {
        const client = this.listClient.find(x => x.value == clientId);
        if (client) {
          this.codeCurrency = client.currency;
          this.formCashReceipt.controls["clientId"].patchValue(clientId);
          this.clientId = clientId;
          this.stateClientId = client.clientStateId;
          this.disabledDetail = true;
        } else {
          this.codeCurrency = "";
          this.formCashReceipt.controls["clientId"].patchValue(0);
          this.clientId = 0;
          this.stateClientId = 0;
          this.disabledDetail = true;
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.formCashReceipt.controls["clientId"].patchValue(clientOld);
        this.toastHandlerService.showToast(
          'warning',
          'No puede limpiar el cliente si la cuenta de cobro tiene detalle.'
        );
      } else {
        this.codeCurrency = "";
        this.formCashReceipt.controls["clientId"].patchValue(0);
        this.clientId = 0;
        this.stateClientId = 0;
        this.disabledDetail = true;
      }
    }
    if (this.incomeConceptCode !== 0 && this.incomeConceptCode != null) {
      if (this.codeCurrency === 'COP') {
        setTimeout(() => this.formControlStateService.setControlState(this.formCashReceipt, ['datePayment', 'commissionValue'], false));
      } else {
        if (this.incomeConceptCode !== IncomeConceptEnum.anticipos) {
          setTimeout(() => this.formControlStateService.setControlState(this.formCashReceipt, ['datePayment', 'commissionValue'], true));
        }
      }
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      if (!response.branchId) {
        this.branchId = 0;
        return;
      }
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getFirstEnterpriseByBranch();
      await this.getAllLists();
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstEnterpriseByBranch() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene Empresas creadas.');
        return;
      };
      this.enterpriseId = response.enterpriseId;
    } catch (error) {
      console.error("Error al obtener la primera empresa de la sucursal: ", error);
    }
  }

  async getIncomeConcept(incomeConceptId: number | null) {
    const incomeConceptOld = this.formCashReceipt.get("incomeConceptId")?.value;
    if (incomeConceptId != null && incomeConceptId != 0) {
      if (incomeConceptOld != incomeConceptId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'warning',
          'No puede cambiar el concepto de ingreso si el recibo de caja tiene detalle.'
        );
      } else {
        const incomeConcept = this.listIncomeConcept.find(x => x.value == incomeConceptId);
        if (incomeConcept) {
          this.formCashReceipt.controls["incomeConceptId"].patchValue(incomeConceptId);
          this.validateIncomeConcept(incomeConceptId);
        } else {
          if (this.quantityDetails != 0) {
            this.toastHandlerService.showToast(
              'warning',
              'Error al buscar el elemento. Por favor refresque la página.'
            );
            return
          } else {
            this.formCashReceipt.controls["incomeConceptId"].patchValue(0);
            return
          }
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'warning',
          'No puede limpiar el concepto de ingreso si el recibo de caja tiene detalle.'
        );
      } else {
        this.formCashReceipt.controls["incomeConceptId"].patchValue(0);
      }
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1, url.indexOf('/', 1));
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    this.isChargeAccount = url !== 'cash-receipt';
    try {
      await this.getPermissionProfileByUrl();
      this.getPermissionsForUserByWindow();
      this.getPermissionPrint();
    } catch (error) {
      console.error('Error al obtener los permisos del perfil por URL.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    if (this.isChargeAccount) {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceiptChargeAccount));
      this.companyId = this.userAuthenticated.companyId;
    } else {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceipt));
      this.companyId = this.userAuthenticated.companyId;
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.cashReceiptService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión.', error);
    }
  }

  async getPrintCashReceiptsByRange(event: any) {
    if (event.printCashReceipt) {
      this.cashReceiptsPrintModel = await firstValueFrom(this.cashReceiptService.getCashReceiptsByKeysByPrintAsync(
        this.cashReceiptContract.branchId, this.cashReceiptContract.enterpriseId, this.isChargeAccount, event.consecutiveInitial, event.consecutiveFinal
      ));
    } else {
      this.cashReceiptsPrintModel = new Array<CashReceiptPrintModel>();
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const baseUrl = this.url.split('/')[0];
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(baseUrl));
      if (!this.permissionUpdatable) {
        this.disabledDetail = true;
        this.disabledForm = true;
        setTimeout(() => this.formCashReceipt.disable());
      }
    } catch (error) {
      this.permissionUpdatable = false;
      console.error('Error al obtener el permiso actualizable por URL.', error);
    }
  }

  async handleInitialState() {
    if (this.cashReceiptId != null && this.cashReceiptId !== 0) {
      await this.getCashReceiptById();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewCashReceipt();
    }
  }

  openPrintingRangeModal() {
    if (this.cashReceiptContract.cashReceiptId === 0 || this.cashReceiptContract.cashReceiptId == null) {
      this.toastHandlerService.showToast('warning', 'Debe crear un recibo de caja.');
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para imprimir recibos de caja. Comuníquese con el administrador del sistema.');
      return;
    }
    if (this.cashReceiptContract.cashReceiptStateId == CashReceiptEnums.abierto || this.cashReceiptContract.cashReceiptStateId == CashReceiptEnums.anulado) {
      this.toastHandlerService.showToast('warning', 'Para imprimir, el recibo de caja debe estar en estado Cerrado.');
      return;
    }

    this.printingRangeModalComponent && this.printingRangeModalComponent.show();
  }

  async send() {
    Object.keys(this.formCashReceipt.controls).forEach(key => {
      const control = this.formCashReceipt.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formCashReceipt.valid) {
      const modelCashReceipt = this.formCashReceipt.value as CashReceiptModel;
      //Hago null, los campos que permiten ser nulos:
      if (modelCashReceipt.description?.trim() === '') modelCashReceipt.description = null;
      if (modelCashReceipt.observation?.trim() === '') modelCashReceipt.observation = null;
      modelCashReceipt.isChargeAccount = this.isChargeAccount;

      if (this.incomeConceptCode == IncomeConceptEnum.pagoFacturas && this.codeCurrency != 'COP'
        && modelCashReceipt.datePayment == null) {
        this.toastHandlerService.showToast(
          'warning',
          'La fecha de pago es obligatoria.'
        );
        return;
      }

      if (this.cashReceiptId == 0) {
        try {
          this.cashReceiptContract = await firstValueFrom(this.cashReceiptService.createCashReceipt(modelCashReceipt));
          this.cashReceiptId = this.cashReceiptContract.cashReceiptId;
          this.validateForm(this.cashReceiptContract);
          this.toastHandlerService.showToast(
            'success',
            'El recibo de caja fue creado exitosamente.'
          );
          this.isChargeAccount ? this.location.replaceState(`/cash-receipt-charge-account/register/${this.cashReceiptId}`) :
            this.location.replaceState(`/cash-receipt/register/${this.cashReceiptId}`);
        } catch (error) {
          console.error('Error al crear el recibo de caja.', error);
        }
      } else {
        this.cashReceiptContract.alterNumber = modelCashReceipt.alterNumber;
        this.cashReceiptContract.dateCashReceipt = modelCashReceipt.dateCashReceipt;
        this.cashReceiptContract.clientId = modelCashReceipt.clientId;
        this.cashReceiptContract.incomeConceptId = modelCashReceipt.incomeConceptId;
        this.cashReceiptContract.description = modelCashReceipt.description;
        this.cashReceiptContract.observation = modelCashReceipt.observation;
        this.cashReceiptContract.otherValues = modelCashReceipt.otherValues;
        this.cashReceiptContract.refundValue = modelCashReceipt.refundValue;
        this.cashReceiptContract.utilizationValue = modelCashReceipt.utilizationValue;
        this.cashReceiptContract.interestValue = modelCashReceipt.interestValue;
        this.cashReceiptContract.accountingInterfaceId = modelCashReceipt.accountingInterfaceId;
        this.cashReceiptContract.commissionValue = modelCashReceipt.commissionValue;
        this.cashReceiptContract.datePayment = modelCashReceipt.datePayment;

        try {
          this.cashReceiptContract = await firstValueFrom(this.cashReceiptService.updateCashReceipt(this.cashReceiptContract));
          this.validateForm(this.cashReceiptContract);
          this.toastHandlerService.showToast(
            'success',
            'El recibo de caja fue modificado exitosamente.'
          );
        } catch (error) {
          console.error('Error al modificar el recibo de caja.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      enterpriseId: {
        required: 'El campo Empresa es obligatorio.',
        min: 'Debe seleccionar una Empresa válida.'
      },
      consecutive: {
        required: 'El campo Consecutivo es obligatorio.'
      },
      dateCashReceipt: {
        required: 'El campo Fecha es obligatorio.'
      },
      rentalPeriodId: {
        required: 'El campo Periodo de Alquiler es obligatorio.'
      },
      clientId: {
        required: 'El campo Cliente es obligatorio.',
        min: 'Debe seleccionar un Cliente válido.'
      },
      incomeConceptId: {
        required: 'El campo Concepto Ingreso es obligatorio.',
        min: 'Debe seleccionar un Concepto Ingreso válido.'
      },
      totalValue: {
        min: 'El campo Vr.Ingreso debe ser mayor o igual a 0.',
        max: 'El campo Vr.Ingreso no puede superar 99,999,999,999.99.'
      },
      otherValues: {
        min: 'El campo Otros Valores debe ser mayor o igual a 0.',
        max: 'El campo Otros Valores no puede superar 99,999,999,999.99.'
      },
      appliedValue: {
        min: 'El campo Valor Aplicado debe ser mayor o igual a 0.',
        max: 'El campo Valor Aplicado no puede superar 99,999,999,999.99.'
      },
      refundValue: {
        min: 'El campo Vr.Reembolso debe ser mayor o igual a 0.',
        max: 'El campo Vr.Reembolso no puede superar 99,999,999,999.99.'
      },
      utilizationValue: {
        min: 'El campo Vr.Aprove/to. debe ser mayor o igual a 0.',
        max: 'El campo Vr.Aprove/to. no puede superar 99,999,999,999.99.'
      },
      interestValue: {
        min: 'El campo Vr.Intereses debe ser mayor o igual a 0.',
        max: 'El campo Vr.Intereses no puede superar 99,999,999,999.99.'
      },
      commissionValue: {
        min: 'El campo Vr.Comisión debe ser mayor o igual a 0.',
        max: 'El campo Vr.Comisión no puede superar 99,999,999,999.99.'
      }
    };


    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formCashReceipt.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState() {
    switch (this.cashReceiptContract.cashReceiptStateId) {
      case CashReceiptEnums.abierto: {
        this.cashReceiptStateString = "Abierto";
        this.iconStateCashReceipt = 'pi pi-lock-open';
        this.titleStateCashReceipt = "Cerrar";
        break;
      }
      case CashReceiptEnums.cerrado: {
        this.cashReceiptStateString = "Cerrado";
        this.iconStateCashReceipt = 'pi pi-lock';
        this.titleStateCashReceipt = "Abrir";
        break;
      }
      case CashReceiptEnums.anulado: {
        this.cashReceiptStateString = "Anulado";
        this.iconStateCashReceipt = 'pi pi-lock';
        this.titleStateCashReceipt = "Abrir";
        break;
      }
    }

    if (this.cashReceiptContract.cashReceiptStateId === CashReceiptEnums.abierto) {
      this.disabledDetail = false;
      this.disabledForm = false;
      setTimeout(() => this.formCashReceipt.enable());
      //Habilitar campos de valores
      this.validateIncomeConcept(this.cashReceiptContract.incomeConceptId);
    } else {
      this.disabledDetail = true;
      this.disabledForm = true;
      setTimeout(() => this.formCashReceipt.disable());
    }

    if (this.cashReceiptContract.cashReceiptId === 0) {
      this.disabledDetail = true;
    }
    setTimeout(() => this.formCashReceipt.controls["totalValue"].disable());
    setTimeout(() => this.formControlStateService.setControlState(this.formCashReceipt, ['branchId', 'enterpriseId'], true));
    if (this.cashReceiptId !== 0) {
      setTimeout(() => this.formCashReceipt.controls["consecutive"].enable());
    } else {
      setTimeout(() => this.formCashReceipt.controls["consecutive"].disable());
    }
  }

  async validateCashReceipt(branchId: number) {
    try {
      const response = await firstValueFrom(this.cashReceiptService.validateCountCashReceiptOpen(branchId, this.isChargeAccount));
      this.companyCashReceiptQuantity = response[0] as number; //Si la cantidad es 0 es porque no hay límite de recibos de cajas abiertos
      this.openCashReceiptQuantity = response[1] as number;
      if (this.openCashReceiptQuantity != 0) {
        if (this.companyCashReceiptQuantity == 0) {
          this.toastHandlerService.showToast(
            'info',
            `Existen (${this.openCashReceiptQuantity}) recibo(s) de caja con estado abierto.`
          );
        } else {
          //Mensaje con el número de recibos
          this.toastHandlerService.showToast(
            'info',
            `Existen (${this.openCashReceiptQuantity}) recibo(s) de caja con estado abierto. El máximo de recibos permitidos son (${this.companyCashReceiptQuantity})`
          );
        }
      }
    } catch (error) {
      console.error("Error al validar la cantidad de recibos de caja abiertos: ", error);
    }
  }

  validateForm(cashReceipt: CashReceiptModel) {
    this.formCashReceipt = this.formBuilder.group({
      branchId: [cashReceipt.branchId, [Validators.required, Validators.min(1)]],
      enterpriseId: [cashReceipt.enterpriseId, [Validators.required, Validators.min(1)]],
      alterNumber: [cashReceipt.alterNumber],
      consecutive: [cashReceipt.consecutive, [Validators.required]],
      dateCashReceipt: [cashReceipt.dateCashReceipt ? this.dateConverterService.convertUtcToLocalDate(cashReceipt.dateCashReceipt) : null, [Validators.required]],
      rentalPeriodId: [cashReceipt.rentalPeriodId, [Validators.required]],
      clientId: [cashReceipt.clientId, [Validators.required, Validators.min(1)]],
      incomeConceptId: [cashReceipt.incomeConceptId, [Validators.required, Validators.min(1)]],
      cashReceiptStateId: [cashReceipt.cashReceiptStateId],
      description: [cashReceipt.description],
      observation: [cashReceipt.observation],
      accountingInterfaceId: [cashReceipt.accountingInterfaceId],
      totalValue: [cashReceipt.totalValue, [Validators.min(0), Validators.max(99999999999.99)]],
      otherValues: [cashReceipt.otherValues, [Validators.min(0), Validators.max(99999999999.99)]],
      appliedValue: [cashReceipt.appliedValue, [Validators.min(0), Validators.max(99999999999.99)]],
      refundValue: [cashReceipt.refundValue, [Validators.min(0), Validators.max(99999999999.99)]],
      utilizationValue: [cashReceipt.utilizationValue, [Validators.min(0), Validators.max(99999999999.99)]],
      datePayment: [cashReceipt.datePayment ? this.dateConverterService.convertUtcToLocalDate(cashReceipt.datePayment) : null],
      interestValue: [cashReceipt.interestValue, [Validators.min(0), Validators.max(99999999999.99)]],
      commissionValue: [cashReceipt.commissionValue, [Validators.min(0), Validators.max(99999999999.99)]],
    });
    if (cashReceipt.cashReceiptId !== 0) {
      this.getClient(this.cashReceiptContract.clientId);
      this.getIncomeConcept(this.cashReceiptContract.incomeConceptId);
      this.getAccountingInterfaceCode(this.cashReceiptContract.accountingInterfaceId);
      this.inputsForPrintingRangeModals$.next({ consecutiveCashReceipt: cashReceipt.consecutive });
    }
    this.updateFormState();
  }

  validateIncomeConcept(incomeConceptId: number) {
    this.incomeConceptCode = this.listIncomeConcept.find(x => x.value == incomeConceptId)?.code as unknown as number;
    if (this.incomeConceptCode !== 0 && this.incomeConceptCode != null) {
      if (this.incomeConceptCode === IncomeConceptEnum.pagoFacturas) {
        setTimeout(() => { this.formCashReceipt.controls["otherValues"].disable() });
        setTimeout(() => this.formControlStateService.setControlState(
          this.formCashReceipt, ['refundValue', 'utilizationValue', 'interestValue', 'commissionValue', 'datePayment'], true
        ));
        this.visibleSelectInvoice = true;
      } else {
        setTimeout(() => { this.formCashReceipt.controls["otherValues"].enable() });
        setTimeout(() => this.formControlStateService.setControlState(
          this.formCashReceipt, ['refundValue', 'utilizationValue', 'interestValue', 'commissionValue', 'datePayment'], false
        ));
        this.visibleSelectInvoice = false;
      }
      if (this.codeCurrency === 'COP') {
        setTimeout(() => this.formControlStateService.setControlState(this.formCashReceipt, ['datePayment', 'commissionValue'], false));
      } else {
        if (this.incomeConceptCode !== IncomeConceptEnum.anticipos) {
          setTimeout(() => this.formControlStateService.setControlState(this.formCashReceipt, ['datePayment', 'commissionValue'], true), 0);
        }
      }
    }
  }

}
